<template>
  <div>
    <form @submit.prevent="onSubmit">
      <div class="field">
        <label class="label"
          >After this page is finished, skip to this page</label
        >
        <div class="select">
          <select v-model="skipTo">
            <option value="null"></option>
            <option
              v-for="page in Object.values(pages)"
              :value="page.id"
              v-bind:key="page.id"
              >{{ page.attributes.title }}</option
            >
            <option disabled value="">--Alternate Endings:--</option>
            <option
              v-for="alternate_ending in Object.values(alternateEndings)"
              :value="alternate_ending.id"
              v-bind:key="alternate_ending.id"
              >{{ alternate_ending.attributes.alternateEndingHeader }}</option
            >
            <option disabled value="">--Default Ending:--</option>
            <option value="summary">Review and Submit</option>
          </select>
        </div>
      </div>
      <div class="field is-grouped mt2 has-text-right">
        <div class="control">
          <button :class="['button', 'is-primary', { 'is-loading': loading }]">
            Update
          </button>
          <button type="button" class="button is-link" @click="$emit('hide')">
            Cancel
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import _ from "lodash";
import InterviewsService from "@/services/InterviewsService";

export default {
  name: "page-logic",

  props: ["page", "interviewId"],

  data() {
    return {
      loading: false,
      skipTo: _.has(this.page.attributes.logic, "skipTo")
        ? this.page.attributes.logic.skipTo
        : null
    };
  },

  computed: {
    pages() {
      const pages = this.$store.state.interview.pages;
      return _.filter(pages, o => o.id !== this.page.id);
    },
    alternateEndings() {
      const alternateEndings = this.$store.state.interview.alternateEndings;
      return alternateEndings;
    }
  },

  methods: {
    onSubmit() {
      this.loading = true;
      const interviewId = this.$route.params.id;
      InterviewsService.pageLogic(
        this.interviewId,
        this.page,
        this.skipTo,
        interviewId
      ).then(() => {
        this.loading = false;
        this.$emit("hide");
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
